module.exports = __webpack_public_path__ + "static/media/event_img-2-3.a00e6fba.png";